import { Component, OnInit } from '@angular/core';
import {ActivatedRoute,Router} from '@angular/router'
import {HttpClient,HttpParams,HttpResponse,HttpHeaders} from '@angular/common/http';
import { environment as configs } from 'src/environments/environment';
import { NzModalService } from 'ng-zorro-antd';
import {CommonService} from '../../common.service'
@Component({
  selector: 'app-payreceipt',
  templateUrl: './payreceipt.component.html',
  styleUrls: ['./payreceipt.component.css']
})
export class PayreceiptComponent implements OnInit {
   host=configs['ApiHost'];
   receiptId:any
   diplayReceipt=false;
   receiptData:any={};
   jsonData:any={};
   userRole;
  constructor(private activeRoute:ActivatedRoute,private httpClient:HttpClient,private confirmServ: NzModalService,private router:Router,public CSF:CommonService) { }
  ngOnInit() {
    this.userRole = JSON.parse(localStorage.getItem('user')).role.toString();
  this.activeRoute.params.subscribe(async e=>{
    this.receiptId=e.id;
    var resp= await this.httpClient.post(this.host+'/payment/receipt/'+this.receiptId,{headers:new HttpHeaders({'Access-Control-Allow-Credentials':'true'}), withCredentials:true}).toPromise()
    // console.log(resp)
    if(resp['data'].length>0){
      let d=resp['data'][0];
      
      if(d.WC_PaymentThrough.toLowerCase()!='online' || d.WC_PaymentThrough.toLowerCase()!='csc' ){
        var paydate=d.WC_PayDateTime.substr(0,10).split('-')
        // let a=paydate[2];
        // paydate[2]=paydate[0];
        // paydate[0]=a
      }else{
        var paydate=d.WC_PayDateTime.split(',')[0].split('-')
      }

      this.receiptData={
        name:d.WRG_Name,
        fname:d.WRG_FatherName,
        dob:d.WRG_DOB,
        fromD:d.WC_StartDate.substr(0,10),
        toD:d.WC_EndDate.substr(0,10),
        Address:d.WRG_Address,
        pmthd:d.WC_PaymentThrough,
        fileNo:d.WC_WorkerRegno,
        circle:d.circle,
        subdiv:d.subdiv,
        transNo:d.WC_TransNo,
        BnkRef:d.WC_BankRefNo,
        feePaid:d.WC_AmountPay,
        years:parseInt(d.WC_Month)/12,
        paydate:this.CSF.dateToYYMMDD(paydate[2]+'-'+paydate[1]+'-'+paydate[0])
      }

      this.jsonData=JSON.stringify({
        N:d.WRG_Name,
        F_HN:d.WRG_FatherName,
        DB:d.WRG_DOB,
        FD:d.WC_StartDate.substr(0,10),
        TD:d.WC_EndDate.substr(0,10),
        FN:d.WC_WorkerRegno,
        TR:d.WC_TransNo,
        BR:d.WC_BankRefNo,
        F:d.WC_AmountPay
      })
    }else{
    }
  })
  }
 goBackESewa(){
     window.location.href=this.host+"/back/to/esewa";
  }
}
